import type { MenuProps } from 'antd'
import { LogoutOutlined, HomeOutlined, CalendarOutlined, UserOutlined, SkinOutlined, TrophyOutlined, TeamOutlined } from '@ant-design/icons'
import { Menu, Layout } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import MenuItem from 'antd/es/menu/MenuItem'
import logoIMG from '../../assets/logoBranco.png'

const colorPalette = {
    primaryColor: '#Fd0178', // Cor principal (base original)
    hoverColor: '#fd338f',  // Tom levemente mais claro para hover
    activeColor: '#e00068', // Tom levemente mais escuro para ativo
    background: '#1a1a1a',  // Fundo escuro para contraste
    textColor: '#ffffff',   // Texto principal
    textSecondary: '#d3d3d3', // Texto para submenus ou menos destacados
}

const { Sider } = Layout

type MenuItem = Required<MenuProps>['items'][number]

function getItem(label: React.ReactNode, key: React.Key, icon?: React.ReactNode, children?: MenuItem[]): MenuItem {
    return {
        key,
        icon,
        children,
        label,
    } as MenuItem
}


const items: MenuItem[] = [
    getItem('Home', '/', <HomeOutlined />),
    getItem('Candidata', '/user', <UserOutlined />, [
        getItem('Meus Dados', '/user/profile'),
        getItem('Minhas Fotos', '/user/picture'),
        getItem('Alterar Senha', '/user/password'),
    ]),
    getItem('Meus Votantes', '/voter', <TeamOutlined />),
    getItem('Sair', '/logout', <LogoutOutlined />),
]

type MenuCustomProps = {
    setIsOpen: (value: boolean) => void
    isOpen: boolean
}



export function MenuCustom(props: MenuCustomProps) {
    const history = useNavigate()
    const location = useLocation()
    const [collapsed, setCollapsed] = useState(false)
    const [openKeys, setOpenKeys] = useState<string[]>([])
    const [selectedKeys, setSelectedKeys] = useState('/logout')

    const onClick: MenuProps['onClick'] = (e) => {
        if (props.isOpen) {
            props.setIsOpen(!props.isOpen)
        }
        setSelectedKeys(e.key)
        if (e.key === '/logout') {
            onLogoutClick()
        } else {
            history(e.key)
        }
    }

    const onLogoutClick = () => {
        localStorage.removeItem('token');
        history('/login')
    }

    const onOpenChange = (keys: string[]) => {
        setOpenKeys(keys)
        localStorage.setItem('isOpenKeys', JSON.stringify(keys))
    }


    const onCollapse = (value: any) => {
        if (props.isOpen) {
            props.setIsOpen(!props.isOpen)
        } else {
            setCollapsed(value)
        }
    }

    useEffect(() => {
        setSelectedKeys(location.pathname)
        const storedMenuState = localStorage.getItem('isOpenKeys')
        if (storedMenuState !== null) {
            setOpenKeys(JSON.parse(storedMenuState))
        }
    }, [location.pathname])

    return (
        <Sider className={`siderbar-menu ${props.isOpen ? 'active' : ''}`}
            collapsible collapsed={collapsed}
            onCollapse={(value) => onCollapse(value)}
            style={{ backgroundColor: colorPalette.background, }}>
            <div style={{ padding: '16px', textAlign: 'center' }}>
                <img
                    src={logoIMG}
                    alt="Logo"
                    style={{ width: collapsed ? '40px' : '120px', transition: 'width 0.3s' }}
                />
            </div>
            <Menu onClick={onClick} theme="dark" mode="inline"
                items={items}
                selectedKeys={[selectedKeys]}
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                style={{
                    backgroundColor: colorPalette.background,
                    color: colorPalette.textColor,
                }}
            />
        </Sider>
    )

}